import React, {
  useEffect,
  useState,
  useContext,
} from 'react'
import { Navigate } from 'react-router-dom'
import { Loader } from 'semantic-ui-react'

import AuthenticationContext from '../contexts/Authentication/AuthenticationContext'

const withAuthentication = (WrappedComponent) => {
  const ComponentWithAuth = (props) => {
    const {
      userCheckSession = () => { },
      isAuthenticated = false,
      isLoading = false,
    } = useContext(AuthenticationContext)
    const [initialCheckDone, setInitialCheckDone] = useState(false)

    useEffect(() => {
      const asyncMethod = async () => {
        await userCheckSession()
        setInitialCheckDone(true)
      }
      asyncMethod()
    }, [])

    // Show loading while initial check is in progress OR while context is loading
    if (!initialCheckDone || isLoading) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#1e1e1e',
        }}
        >
          <Loader active inline="centered" size="large" inverted>
            Vérification de la session...
          </Loader>
        </div>
      )
    }

    // Redirect to login if not authenticated
    if (!isAuthenticated) {
      console.log('🔒 User not authenticated, redirecting to login')
      return <Navigate to="/" />
    }

    return <WrappedComponent {...props} />
  }

  return ComponentWithAuth
}

export default withAuthentication
